import { atom } from 'recoil'

export const idsState = atom({
  key: 'EmailSendingQueueManage__idsState',
  default: {
    idMessage: 0,
    idSending: 0,
    idAbTest: 0
  }
})
export const timeAndCountState = atom({
  key: 'EmailSendingQueueManage__timeAndCountState',
  default: {
    recipientCount: 0,
    estimatedTime: 0,
    queued: 0
  }
})
